module.exports = __webpack_public_path__ + "media/images/tiedye/cloud-nine-texture-3b918f7dcbd95c198f8a277e4653958d.jpg";